import { render, staticRenderFns } from "./ui-news-vertical.vue?vue&type=template&id=bcf8f1f4&"
import script from "./ui-news-vertical.vue?vue&type=script&lang=ts&"
export * from "./ui-news-vertical.vue?vue&type=script&lang=ts&"
import style0 from "./ui-news-vertical.vue?vue&type=style&index=0&id=bcf8f1f4&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports